module.exports = __webpack_public_path__ + "static/media/Corona-Hinweis-Kl3.26dd6503.jpg";